import React, { Component } from 'react'
import styled from 'styled-components'
import { apiFetch, uploadToS3, getTheme, viewportWidth } from 'helpers'
import { get } from 'lodash'
import ReviewStars from 'components/ReviewStars'
import svgCamera from 'assets/svg/icon-camera.svg'

export default class extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  _onLogoChosen = (e) => {
    const file = get(e, 'currentTarget.files.0')
    this.setState({ logoUploading: true }, () =>
      apiFetch({
        method: 'POST',
        v4: true,
        url: '/v4/s3/signed-url',
        body: {
          collectionName: 'vendors',
          folderName: get(this.props, 'me._id'),
          fileName: `logo-${new Date().getTime()}.${file.type.split('/').pop()}`,
          fileType: file.type
        }
      })
        .then(({ url }) => uploadToS3({ url, file }))
        .then(imageUrl =>
          apiFetch({
            method: 'PUT',
            v4: true,
            url: '/v4/vendors/me',
            body: { logoPath: imageUrl }
          })
            .then(() => this.setState({ logoUploading: false }, () => {
              this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'แก้ไขภาพโลโก้สำเร็จ' })
              this.props.dispatch({ type: 'UPDATE_PROFILE', logoPath: imageUrl })
            }))
            .catch((error) => this.setState({ error, logoUploading: false }, () =>
              this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'แก้ไขภาพโลโก้ไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' })
            ))
        )
    )
  }

  render () {
    const { me, history } = this.props
    return (
      <Container>
        <LogoWrapper onClick={() => this.refs.logoChooser.click()}>
          <Logo src={get(me, 'logoPath')} />
          <BtnEditLogo>
            <IconCamera src={svgCamera} />
          </BtnEditLogo>
        </LogoWrapper>
        <input ref='logoChooser' type='file' style={{ display: 'none' }} onChange={this._onLogoChosen} />
        <InfoWrapper>
          <VendorName>{get(me, 'nameEn') || get(me, 'nameTh')}</VendorName>
          <ReviewStars score={get(me, 'reviewScore')}>
            <ReviewCount>{get(me, 'reviewCount') || 0} รีวิว</ReviewCount>
          </ReviewStars>
        </InfoWrapper>
        <BtnEditSettingsWrapper>
          <BtnEditSettings onClick={() => viewportWidth() < 768 ? history.replace('/settings/info') : history.push('/settings/info')}>แก้ไขโปรไฟล์ร้าน</BtnEditSettings>
        </BtnEditSettingsWrapper>
      </Container>
    )
  }
}

const Container = styled.div`
  background-color: white;
  border-bottom: 1px solid ${getTheme`colorBorder`};
  position: relative;
  @media(min-width: 768px) {
    padding: 20px;
  }
  @media(max-width: 767px) {
    padding: 10px;
  }
`
const LogoWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  position: relative;
`
const Logo = styled.img`
  display: block;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background-color: ${getTheme`colorImageBackground`};
  @media(max-width: 414px) {
    width: 70px;
    height: 70px;
  }
`
const BtnEditLogo = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  line-height: 30px;
  right: -5px;
  bottom: -5px;
  border-radius: 50%;
  text-align: center;
  background-color: ${getTheme`colorGray`};
`
const IconCamera = styled.img`
  width: 15px;
  line-height: 30px;
`
const InfoWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
`
const VendorName = styled.h1`
  margin: 0px;
  padding: 0px;
  font-weight: normal;
  @media(min-width: 768px) {
    font-size: 32px;
    line-height: 48px;
    margin-bottom: 12px;
  }
  @media(max-width: 767px) {
    font-size: 24px;
    line-height: 36px;
  }
`
const ReviewCount = styled.div`
  display: inline-block;
  vertical-align: top;
  @media(min-width: 768px) {
    font-size: 18px;
    line-height: 21px;
    margin-left: 10px;
  }
  @media(max-width: 767px) {
    font-size: 14px;
    line-height: 19px;
    margin-left: 5px;
  }
`
const BtnEditSettingsWrapper = styled.div`
  @media(min-width: 768px) {
    position: absolute;
    top: 20px;
    right: 20px;
  }
  @media(max-width: 767px) {
    margin-top: 10px;
    margin-left: -10px;
    margin-right: -10px;
    border-top: 1px solid ${getTheme`colorBorder`};
    padding: 10px;
    padding-bottom: 0px;
  }
`
const BtnEditSettings = styled.div`
  border-radius: 5px;
  background-color: ${getTheme`colorTiffanyDark`};
  color: white;
  text-align: center;
  border-color: transparent;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
  
  @media(min-width: 768px) {
    font-size: 20px;
    line-height: 60px;
    padding: 0px 30px;
  }
  @media(max-width: 767px) {
    font-size: 18px;
    line-height: 50px;
  }
`



// WEBPACK FOOTER //
// ./src/components/profile/SectionBasicInfo.js